import React from 'react';
import cache from '../../content/substack-cache.json';

const SUBSTACK_HOME = 'https://aberrest.substack.com';

function isPost(post) {
  return Boolean(
    post
    && typeof post.title === 'string'
    && post.title.trim()
    && typeof post.url === 'string'
    && post.url.startsWith('https://')
  );
}

function formatPublishedDate(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}

const posts = (Array.isArray(cache.posts) ? cache.posts : []).filter(isPost).slice(0, 3);

const WritingCard = ({ post }) => {
  const dateLabel = formatPublishedDate(post.publishedAt);

  return (
    <a
      className="latest-writing-card"
      href={post.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <h3 className="latest-writing-card-title">{post.title}</h3>
      {post.description ? (
        <p className="latest-writing-card-description">{post.description}</p>
      ) : null}
      {dateLabel ? (
        <time className="latest-writing-card-date" dateTime={post.publishedAt}>
          {dateLabel}
        </time>
      ) : null}
      <span className="latest-writing-newtab">opens in a new tab</span>
    </a>
  );
};

const FallbackCard = () => (
  <a
    className="latest-writing-card latest-writing-card--fallback"
    href={SUBSTACK_HOME}
    target="_blank"
    rel="noopener noreferrer"
  >
    <h3 className="latest-writing-card-title">Read on Substack</h3>
    <p className="latest-writing-card-description">
      Essays from Aberrest publish on Substack.
    </p>
    <span className="latest-writing-newtab">opens in a new tab</span>
  </a>
);

const LatestWriting = () => (
  <section className="latest-writing" aria-labelledby="latest-writing-title">
    <h2 id="latest-writing-title" className="latest-writing-title">Latest writing</h2>
    <div className="latest-writing-grid">
      {posts.length ? posts.map((post) => (
        <WritingCard key={post.url} post={post} />
      )) : (
        <FallbackCard />
      )}
    </div>
  </section>
);

export default LatestWriting;
